import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import profileimg1 from "../../assets/images/users/user-dummy-img.jpg";
import { createSelector } from 'reselect';
import { authConfig, UserManagerInstance } from './functions/authConfig';
import { useNavigate } from 'react-router-dom';
import { fetchDocumentsForCustomer } from '../../slices/customer/documentlist/thunk';
import { viewDoc } from '../../slices/customer/documentview/thunk';
import { systemUserLogoViewDoc } from '../../slices/Logo/SystemUserViewLogo/thunk';
import { ProfilelogoDoc } from '../../slices/Logo/ProfileLogo/thunk';
import { determineBaseUrlAndPerformApiCall } from '../../slices/interceptor/interceptor';
import { LOGOUT_API } from '../../slices/constants/constants';
import { getMLAppWindow } from '../Utils/MLUtils';
import { hasPermission } from '../Utils/UtilityFunctions';
import { keycloak } from './functions/keycloakConfig';

const ProfileDropdown = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const userId = localStorage.getItem('userId')
    const roleName = localStorage.getItem("roleName")
    const [loading, setLoading] = useState(false)
    const [profileData, setProfileData] = useState()
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const profilePermission = hasPermission(permissionsMap, "administration", "profilemanagement");

    function clearAuth() {
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('permissionss');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('roleName');
        localStorage.removeItem('operatorId');
        localStorage.removeItem('customerId');
        localStorage.removeItem('operatorName');
        localStorage.removeItem('userName');
        localStorage.removeItem('PartnerId');
        localStorage.removeItem('searchResponses');
        localStorage.removeItem('environment');
    }

    const handleLogout = async () => {
        const environment = (localStorage.getItem("environment"));
        const redirectedToUMP = localStorage.getItem("redirectedToUMP") === "true";
        const mlWindow = redirectedToUMP ? getMLAppWindow() : null;
        const mlOrigin = redirectedToUMP ? new URL(window.env.REACT_APP_ML_REDIRECT_URL).origin : "";

        const notifyMLApp = (token = "", refreshToken = "") => {
            if (redirectedToUMP && mlWindow) {
                mlWindow.postMessage({ token, refreshToken, redirectedFromUMP: "true", userName }, mlOrigin);
            }
        };

        try {
            if (environment?.toLowerCase() === "native") {
                const response = await determineBaseUrlAndPerformApiCall(`${LOGOUT_API}`, 'PUT', "");

                if (response?.accessToken) {
                    notifyMLApp(response.accessToken);
                }

                window.location.href = `${process.env.PUBLIC_URL}/logout`;
            } else if (environment?.toLowerCase() === "azure" || environment?.toLowerCase() === "google" || environment?.toLowerCase() == "keycloak"){
                keycloak.logout({
                    redirectUri: `${window.env.REACT_APP_UI_URL}/signin`
                });
                localStorage.removeItem("id_token");
                localStorage.removeItem("redirect_url")
            } else {
                notifyMLApp(); // clear tokens for non-Native flow

                UserManagerInstance.signoutRedirect({
                    post_logout_redirect_uri: authConfig.post_logout_redirect_uri,
                });
            }
            localStorage.removeItem("currencySymbol")
        } catch (error) {
            console.error("Error during logout:", error);
        } finally {
            clearAuth(); // Always clear local tokens, etc.
        }
    };


    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    const userName = localStorage.getItem('userName') || '';
    const customerId = localStorage.getItem('customerId') || '';

    useEffect(() => {
        if (roleName === "telcoAdmin" || roleName === "operatorAdmin" || roleName === "genericAdmin" || roleName === "ISPOperatorAdmin" || roleName === "providerOperationUser" || roleName === "operatorOperationUser" || roleName === "operatorBusinessUser" || roleName === "telcoOperationUser" || roleName === "telcoBusinessUser" || roleName === "genericOperationUser" || roleName === "genericBusinessUser" || roleName === "ISPOperationUser" || roleName === "ISPBusinessUser" || roleName === "SGCAdmin" || roleName === "SGCExecutiveUser" || roleName === "SGCOperationsUser" || roleName === "SGCPowerUser") {
            let partnerOrCustomer = "User"
            dispatch(ProfilelogoDoc(setLoading, userId, "logo", partnerOrCustomer, setProfileData));
        }
        else if (roleName === "systemUser") {
            let partnerOrCustomer = "User"
            dispatch(systemUserLogoViewDoc(setLoading, userId, "logo", partnerOrCustomer, setProfileData));
        }
        else if (roleName === "Customer") {
            let partnerOrCustomer = "Customer"
            dispatch(ProfilelogoDoc(setLoading, customerId, "logo", partnerOrCustomer, setProfileData));
        }
        else if (roleName === "ISPPartnerAdmin") {
            let partnerOrCustomer = "Partner"
            const partnerId = localStorage.getItem('PartnerId')
            dispatch(viewDoc(setLoading, partnerId, "logo", partnerOrCustomer, setProfileData));
        }
    }, [dispatch])
    let base64ImageData = []
    let profile = useSelector((state) => state.ViewDocument.documentView)
    let ViewDocument = useSelector((state) => state.ProfileLogo.profileLogo);
    let systemUserProfile = useSelector((state) => state.SystemLogoView.logoView)
    if (roleName === "systemUser") {
        base64ImageData = systemUserProfile?.filePath
    }
    else if (roleName === "Customer" || roleName === "telcoAdmin" || roleName === "operatorAdmin" || roleName === "genericAdmin" || roleName === "ISPOperatorAdmin" || roleName === "providerOperationUser" || roleName === "operatorOperationUser" || roleName === "operatorBusinessUser" || roleName === "telcoOperationUser" || roleName === "telcoBusinessUser" || roleName === "genericOperationUser" || roleName === "genericBusinessUser" || roleName === "ISPOperationUser" || roleName === "ISPBusinessUser" || roleName === "SGCAdmin"|| roleName === "SGCExecutiveUser" || roleName === "SGCOperationsUser" || roleName === "SGCPowerUser") {
        base64ImageData = ViewDocument?.filePath
    }
    else {
        base64ImageData = profile?.filePath
    }
    // const operatorId = localStorage.getItem('operatorId') || '';
    // const initialValues = [];
    // const operatorOptions=[];
    // const OperatorStatusOptions=[];
    // useEffect(() => {
    //         dispatch(fetchOperatorbyId(setLoading, operatorId, initialValues, operatorOptions, OperatorStatusOptions));
    // }, [dispatch]);

    // const operatorData = useSelector((state) => state?.GetOperator?.GetOperatorId ?? null);
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="header-item ">
                <DropdownToggle tag="button" type="button" className="btn shadow-none">
                    <span className="d-flex align-items-center">
                        <i className="ri-account-circle-line fs-3 text-muted"></i>
                        {/* <img className="rounded-circle header-profile-user me-2" src={profileData ? base64ImageData : profileimg1} alt="Header Avatar" />
                        <span className="text-center ms-xl-2">
                            <span className="d-block fw-medium user-name-text">
                                {userName}
                            </span>
                            // <span className="d-block fw-medium user-name-text">
                            //     {operatorNameFinal}
                            // </span>
                        </span> */}
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {localStorage.getItem('userName')}!</h6>
                    {/* <DropdownItem ><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Profile</span></DropdownItem> */}
                    <DropdownItem ><i
                        className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Help</span></DropdownItem>
                    {(roleName !== 'ISPPartnerAdmin' || profilePermission) && (
                        <>
                            <DropdownItem onClick={() => {
                                if (roleName === "Customer") {
                                    navigate("/customer/profile")
                                }
                                else {
                                    navigate(`/profile`)
                                }
                            }} ><i
                                className="ri-profile-line text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle"  >Profile</span></DropdownItem>
                        </>
                    )}
                    <div className="dropdown-divider"></div>

                    {/* <DropdownItem onClick={() => navigate(`/edit-user/${userId}`, { state: { changePassword: true } })}><i
                        className="ri-lock-password-line text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Change Password</span></DropdownItem>
                    <div className="dropdown-divider"></div> */}
                    {/* <DropdownItem><i
                        className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Balance : <b>$00.00</b></span></DropdownItem> */}
                    <DropdownItem onClick={handleLogout}>
                        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle" data-key="t-logout">Logout</span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;